<!-- Contenitore focusabile del gruppo -->
<div 
  class="row custom-radio-group"
  role="radiogroup"
  tabindex="0"
  [attr.aria-labelledby]="randomValueString + '_label'"
  [attr.aria-describedby]="randomValueString + '_descrizione'"
>   
  <div class="col-sm-12">
    <!-- Etichetta principale -->
    <div class="form-label {{labelClass}}" [attr.id]="randomValueString + '_label'">
      <b>{{ labelInput }}</b>
      <span *ngIf="mandatory" class="mandatory" aria-hidden="true">*</span>
    </div>

    <!-- Opzioni radio -->
    <div class="row">
      <div class="col-md-3 col-sm-6 text-center custom-radio">
        <input 
          type="radio"
          class="custom-radio-input"
          [attr.id]="'default_si_' + randomValueString"
          [name]="randomValueString"
          [checked]="objectReference === true"
          [disabled]="submitPending"
          (change)="onReturn.emit(true)">
        <label class="custom-radio-label" [attr.for]="'default_si_' + randomValueString">
          {{ labelChecked }}
        </label>
      </div>

      <div class="col-md-3 col-sm-6 text-center custom-radio">
        <input 
          type="radio"
          class="custom-radio-input"
          [attr.id]="'default_no_' + randomValueString"
          [name]="randomValueString"
          [checked]="objectReference === false"
          [disabled]="submitPending"
          (change)="onReturn.emit(false)">
        <label class="custom-radio-label" [attr.for]="'default_no_' + randomValueString">
          {{ labelNotChecked }}
        </label>
      </div>
    </div>

    <small [attr.id]="randomValueString + '_descrizione'" class="sr-only">
      Usa le frecce per selezionare una delle due opzioni di {{labelInput}}: {{ labelChecked }} o {{ labelNotChecked }}.
    </small>
  </div>
</div>
